/**
 * @voltxampere/ui — 8x8 LED matrix display variant (Sprint 43-7, placeholder)
 *
 * PLACEHOLDER. 64-LED 8-row × 8-column matrix display, typical row /
 * column scan addressing. Real per-LED simulation + scan-line driver
 * lands Sprint 47+ along with display full-simulation.
 *
 * Reference: Generic 1088AS / 1088BS class 8x8 LED matrix.
 *
 * Engine zero-diff invariant honored — canonical `voltage-source`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const displayLedMatrix8x8 = {
    id: "led-matrix-8x8",
    nameTr: "8x8 LED Matrix (1088AS, placeholder)",
    nameEn: "8x8 LED Matrix (1088AS, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "DS",
    defaultValue: "LED-MATRIX-8x8",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=display-led-matrix-8x8.js.map